module.exports = __webpack_public_path__ + "static/media/user-card@2x.389a53e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_31/imgs/user-card@2x.png
// module id = 878
// module chunks = 0